import { createApp } from 'vue'
import App from './App.vue'
import './assets/style.scss'

createApp(App).mount('#app')
